/* eslint-disable react/jsx-no-bind */
/* eslint-disable react/no-danger */
import React from 'react';
import { v4 as uuidv4 } from 'uuid';
import { faChevronRight } from '@fortawesome/pro-light-svg-icons';
import { Link } from 'gatsby';
import { StyledProjectsTable } from './styles';
import { Project } from './types';
import { SimpleModal } from '../SimpleModal';
import { Slider } from '../Slider';
import { projectMock } from './mocks';
import { ProjectThumbnail } from '../ProjectThumbnail';
import { Button } from '../Button';

export interface IProjectsTable {
  data: Project[];
  className?: string;
  slider?: boolean;
}

export const ProjectsTable = ({
  className,
  data,
  slider = true,
}: IProjectsTable) => {
  const [modalIsOpen, setIsOpen] = React.useState(false);
  const [selectedProject, setSelectedProject] =
    React.useState<Project>(projectMock);

  function openModal() {
    setIsOpen(true);
  }

  function closeModal() {
    setIsOpen(false);
  }

  const settingsSlider = {
    slidesToShow: 5,
    slidesToScroll: 1,
    infinite: false,
    rows: 1,
    slidesPerRow: 1,
  };

  const settingsSliderPhoneResponsive = {
    slidesToScroll: 1,
    rows: 3,
    slidesPerRow: 1,
  };

  const settingsSliderPhabletResponsive = {
    slidesToScroll: 1,
    rows: 2,
    slidesPerRow: 1,
  };

  const settingsSliderTabletResponsive = {
    slidesToScroll: 1,
  };

  const itemsToRender = data.map((project: Project) => {
    const { thumbnailImage, thumbnailTitle } = project;
    return (
      <Slider.Button
        key={uuidv4()}
        onClick={() => {
          setSelectedProject(project);
          openModal();
        }}
      >
        <ProjectThumbnail
          title={thumbnailTitle}
          image={thumbnailImage.gatsbyImageData}
          alt={thumbnailImage.description}
        />
      </Slider.Button>
    );
  });

  return (
    <StyledProjectsTable className={className}>
      {slider ? (
        <Slider
          settings={settingsSlider}
          responsivePhoneSettings={settingsSliderPhoneResponsive}
          responsivePhabletSettings={settingsSliderPhabletResponsive}
          responsiveTabletSettings={settingsSliderTabletResponsive}
          paginationMargin="24px"
        >
          {itemsToRender}
        </Slider>
      ) : (
        <div className="list-container">
          <div className="list">{itemsToRender}</div>
        </div>
      )}

      <SimpleModal
        onClose={closeModal}
        isOpen={modalIsOpen}
        title={selectedProject.thumbnailTitle}
        image={{
          gatsbyImageData: selectedProject.thumbnailImage.gatsbyImageData,
          title: selectedProject.thumbnailImage.description,
        }}
        imageWidth="187px"
        imageHeight="90px"
        stretch
        center
        content={selectedProject.description.description}
        footer={
          <Link to={`/projects/${selectedProject.slug}`}>
            <Button
              className="modal-btn"
              size="small"
              disabled={false}
              iconRight={faChevronRight}
            >
              Case study
            </Button>
          </Link>
        }
      />
    </StyledProjectsTable>
  );
};
